import { getAccessToken } from './auth';
const API_BASE = import.meta.env.VITE_API_BASE;
export class ApiError extends Error {
    status;
    constructor(message, status) {
        super(message);
        this.status = status;
        this.name = 'ApiError';
    }
}
async function request(path, init = {}) {
    const token = await getAccessToken();
    const res = await fetch(`${API_BASE}${path}`, {
        ...init,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            ...(init.headers || {}),
        },
    });
    if (!res.ok) {
        let message = `Request failed (${res.status})`;
        try {
            const body = await res.json();
            message = body.error || message;
        }
        catch {
            /* ignore */
        }
        throw new ApiError(message, res.status);
    }
    return res.json();
}
export async function getJobs() {
    const body = await request('/jobs');
    return body.jobs;
}
export async function getTemplates() {
    const body = await request('/swms/templates');
    return body.templates;
}
export async function getProfile() {
    const body = await request('/m365/profile');
    return body.profile;
}
export async function submitSwms(submission) {
    const body = await request('/swms/submit', {
        method: 'POST',
        body: JSON.stringify(submission),
    });
    return body.record;
}
